<div class="dialog-header">
  <p class="dialog-title">{{ title }}</p>
  @if (showCloseButton) {
    <button type="button" class="dialog-close-btn" aria-label="Close" [disabled]="disabled" (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  }
</div>
